export default "__VITE_ASSET__CGubipRe__"